import { render, staticRenderFns } from "./packageticket.vue?vue&type=template&id=ae09e2d6&scoped=true"
import script from "./packageticket.vue?vue&type=script&lang=js"
export * from "./packageticket.vue?vue&type=script&lang=js"
import style0 from "./packageticket.vue?vue&type=style&index=0&id=ae09e2d6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae09e2d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae09e2d6')) {
      api.createRecord('ae09e2d6', component.options)
    } else {
      api.reload('ae09e2d6', component.options)
    }
    module.hot.accept("./packageticket.vue?vue&type=template&id=ae09e2d6&scoped=true", function () {
      api.rerender('ae09e2d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scenic-spot/packageticket.vue"
export default component.exports